import { PageHeader } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

const ImportAnnouncementsPageHeader = () => {
  const { t } = useTranslation()
  return <PageHeader ghost={false} title={t('components.pages.employees.imports.pageHeader.title')} />
}

ImportAnnouncementsPageHeader.displayName = 'ImportAnnouncementsPageHeader'
export default ImportAnnouncementsPageHeader
